module.exports = __webpack_public_path__ + "img/50.7ad03f14.jpg";